<div [ngClass]="{ dark: this.themeService.isDark }">
  <router-outlet></router-outlet>
  <app-responsive-helper></app-responsive-helper>
  <p-toast></p-toast>
</div>
